import { render, staticRenderFns } from "./JoinProvider.vue?vue&type=template&id=ba889f8a&"
import script from "./JoinProvider.vue?vue&type=script&lang=ts&"
export * from "./JoinProvider.vue?vue&type=script&lang=ts&"
import style0 from "./JoinProvider.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports